import React from 'react';
import AppToast from '../ui/AppToast';
import { isOwnerEngineerSame, OWNER_ENGINEER_WARNING_MSG } from '../helpers/ownerEngineerValidation';
import Modal from '@material-ui/core/Modal';
import Alert from '@material-ui/lab/Alert';
import AppButton from '../ui/AppButton';

/**
 * Componente que valida si los documentos coinciden y muestra un toast si es así.
 * @param {string} docProp - Documento del propietario
 * @param {string} docEng - Documento del ingeniero/electricista
 * @param {React.ReactNode} children - Elementos hijos
 */

const OwnerEngineerValidator = ({ docProp, docEng, children, useModal = false }) => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (isOwnerEngineerSame(docProp, docEng)) {
      if (useModal) {
        setOpen(true);
      } else {
        AppToast(OWNER_ENGINEER_WARNING_MSG, false);
      }
    } else {
      setOpen(false);
    }
    // eslint-disable-next-line
  }, [docProp, docEng, useModal]);

  const handleClose = () => setOpen(false);

  return (
    <>
      {children}
      {useModal && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="owner-engineer-modal-title"
          aria-describedby="owner-engineer-modal-desc"
          disableBackdropClick={true}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Alert severity="warning" style={{ textAlign: 'justify', width: 400, background: '#fff' }}>
            <div style={{ marginBottom: 16 }}>{OWNER_ENGINEER_WARNING_MSG}</div>
            <AppButton label="Cerrar" size="small" onClick={handleClose} />
          </Alert>
        </Modal>
      )}
    </>
  );
};

export default OwnerEngineerValidator;
